/** @format */

export const colorPalette = {
	saphir: "#4D54C5",
	lighterSaphir: "#E8E9FD",
	greyLight: "#E1E1E1",
	greyLightBis: "#DDDDDD",
	lightBlue: "#7088FD",
	red: "#e00034",
	lunarRock: "#C5C5C5"
}

export const colors = {
	C01: "#e4f7f5",
	C02: "#fbeeee",
	C03: "#227c59",
	C04: "#c52a2a",
	C05: "#e8e9fd",
	C06: "#6a6eaa",
	C07: "#4d54c5",
	C08: "#2b2b2b",
	C09: "#fdf2e4",
	C10: "#eef5f2",
	C11: "#29347d",
	C12: "#f8f8f8",
	C13: "#eaeaea",
	C14: "#ffffff",
	C15: "#929292",
	C16: "#000000",
	C17: "#dddddd",
	C18: "rgba(230, 230, 230, 0.5)",
	C19: "#e1e1e1",
	C20: "#f5a623",
}
